import { uttarakhandDistrictList } from "../config/districtConfig";
import { nodalOfficersRoleList } from "../config/roleConfig";

export const profileFormFields = [
  {
    title: "",
    fields: [
      {
        divClass: "",
        label: "Title",
        htmlFor: "title",
        inputProps: {
          id: "title",
          name: "title",
          type: "select",
          disabled: false,
          placeholder: "Select Title",
          options: [
            { label: "Mr", value: "1" },
            { label: "Ms", value: "2" },
            { label: "Mrs", value: "3" },
          ],
          validation: {
            required: true,
            message: "Please select Title",
          },
        },
      },
      {
        divClass: "",
        label: "Username",
        htmlFor: "username",
        inputProps: {
          id: "username",
          name: "username",
          type: "text",
          placeholder: "Enter username",
          disabled: false,
          validation: {
            required: true,
            message: "Username is required.",
          },
        },
      },
      {
        divClass: "",
        label: "Email",
        htmlFor: "email",
        inputProps: {
          id: "email",
          name: "email",
          type: "email",
          placeholder: "Enter email",
          disabled: false,
          validation: {
            required: true,
            pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Enter a valid email.",
          },
        },
      },
      {
        divClass: "",
        label: "Phone Number",
        htmlFor: "phone_number",
        inputProps: {
          id: "phone_number",
          name: "phone_number",
          type: "text",
          placeholder: "Enter phone number",
          disabled: false,
          maxLength: "10",
          validation: {
            required: true,
            pattern: /^[0-9]{10}$/,
            message: "Enter a valid 10-digit phone number.",
          },
        },
      },
      {
        divClass: "",
        label: "Address",
        htmlFor: "address",
        inputProps: {
          id: "address",
          name: "address",
          type: "text",
          placeholder: "Enter Address",
          disabled: false,
          validation: {
            required: true,
            message: "Address is required.",
          },
        },
      },
      {
        divClass: "",
        label: "Upload Profile Image",
        htmlFor: "upload_profile",
        inputProps: {
          id: "upload_profile",
          name: "upload_profile",
          type: "file",
          placeholder: "Upload profile image",
          disabled: false,
          validation: {
            required: false,
            message: "File upload failed.",
          },
        },
      },
    ],
  },
];

export const nodalOfficersFormFields = [
  {
    title: "",
    fields: [
      {
        divClass: "",
        label: "Name",
        htmlFor: "name",
        inputProps: {
          id: "name",
          name: "name",
          type: "text",
          placeholder: "Enter Name",
          disabled: false,
          validation: {
            required: true,
            message: "Name is required.",
          },
        },
      },
      {
        divClass: "",
        label: "Email",
        htmlFor: "email",
        inputProps: {
          id: "email",
          name: "email",
          type: "email",
          placeholder: "Enter email",
          disabled: false,
          validation: {
            required: true,
            pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Enter a valid email.",
          },
        },
      },
      {
        divClass: "",
        label: "Username",
        htmlFor: "username",
        inputProps: {
          id: "username",
          name: "username",
          type: "text",
          placeholder: "Enter Username",
          disabled: false,
          validation: {
            required: true,
            message: "Username is required",
          },
        },
      },
      {
        divClass: "",
        label: "Mobile Number",
        htmlFor: "mobile_number",
        inputProps: {
          id: "mobile_number",
          name: "mobile_number",
          type: "text",
          placeholder: "Enter mobile number",
          disabled: false,
          maxLength: "10",
          validation: {
            required: true,
            pattern: /^[0-9]{10}$/,
            message: "Enter a valid 10-digit phone number.",
          },
        },
      },
      {
        divClass: "",
        label: "Address",
        htmlFor: "address",
        inputProps: {
          id: "address",
          name: "address",
          type: "text",
          placeholder: "Enter Address",
          disabled: false,
          validation: {
            required: true,
            message: "Address is required.",
          },
        },
      },
      {
        divClass: "",
        label: "Role",
        htmlFor: "role_id",
        inputProps: {
          id: "role_id",
          name: "role_id",
          type: "select",
          disabled: false,
          placeholder: "Select Role",
          options: nodalOfficersRoleList,
          validation: {
            required: true,
            message: "Please select Role",
          },
        },
      },
      {
        divClass: "",
        label: "District",
        htmlFor: "district_name",
        inputProps: {
          id: "district_name",
          name: "district_name",
          type: "select",
          disabled: false,
          placeholder: "Select District",
          options: uttarakhandDistrictList,
          validation: {
            required: true,
            message: "Please select District",
          },
        },
      },
    ],
  },
];

export const changePasswordFormFields = [
  {
    title: "",
    fields: [
      {
        divClass: "",
        label: "Old Password",
        htmlFor: "oldpass",
        inputProps: {
          id: "oldpass",
          name: "oldpass",
          type: "password",
          placeholder: "Enter Old Password",
          disabled: false,
          validation: {
            required: true,
            message: "Enter valid old password.",
          },
        },
      },
      {
        divClass: "",
        label: "New Password",
        htmlFor: "newpass",
        inputProps: {
          id: "newpass",
          name: "newpass",
          type: "password",
          placeholder: "Enter New Password",
          disabled: false,
          validation: {
            required: true,
            pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
            message:
              "Password must contain at least 8 characters including 1 uppercase, 1 lowercase, 1 number, and 1 special character.",
          },
        },
      },
      {
        divClass: "",
        label: "Confirm Password",
        htmlFor: "confirmpass",
        inputProps: {
          id: "confirmpass",
          name: "confirmpass",
          type: "password",
          placeholder: "Enter Confirm Password",
          disabled: false,
          validation: {
            required: true,
            message: "Confirm Password is required.",
          },
        },
      },
    ],
  },
];
